import { CheckIcon } from "@gsd/backoffice-ui";
import { Column } from "react-table";

const UserTableSettings: Array<Column> = [
  {
    Header: "Verificato",
    id: "emailVerified",
    accessor: row => row.emailVerified || false,
    Cell:row=> {
      const { value } = row;
      return (
        <div className="d-flex justify-content-center">
          {
            value === true
              ? <CheckIcon width={32} />
              : null
          }
        </div>
      );
    },
    width: 100,
  },
  {
    Header: "Username",
    accessor: "email",
    id: "email",
    Cell:row=> {
      const { value, original : { enabled }} = row;
      return (
        <span>
          { enabled === true ? value : `[Eliminato] ${value}`}
        </span>
      );
    },

  },
  {
    Header: "Nome",
    accessor: "name"
  },
  {
    Header: "Cognome",
    accessor: "lastname",
    id: "surname"
  },
];

const PermissionTableSettings: Array<Column> = [
  {
    Header: "Applicazione",
    accessor: "name",
    width: 200,
  },
  {
    Header: "Prefisso",
    accessor: "rolePrefix",
    Aggregated: row => {
      return "";
    }
  },
  {
    Header: "Ruolo",
    accessor: "roleName",
    Aggregated: row => {
      return "";
    },
  },
  {
    Header: "Suffisso",
    accessor: "rolePostfix",
    Aggregated: row => {
      return "";
    }
  },
  {
    Header: "ACL",
    id: "acls",
    Aggregated: row => {
      return "";
    },
    accessor: row => {
      return (row.acls || []).map (el => {
        return el.label;
      }).join(" ");
    }
  }

];
export {
  UserTableSettings,
  PermissionTableSettings
};
